import React, { useEffect } from "react";
import './OpenRom.css';
import { ReactComponent as OpenFolder } from './open-folder.svg';

const OpenRom = ({ rom, setRom }) => {
    useEffect(() => {
        let input = document.getElementById('input');
        input.onchange = (event) => {
            let file = event.target.files[0];
            if (file) {
                setRom(file);
            }
        };

        document.getElementsByClassName('OpenRom__Card')[0].onclick = () => {
            input.click();
        }
    }, [])
    const open_rom = () => {

    }
    return (
        <div className={"OpenRom__Card"}>
            <input id="input" type="file" style={{ display: 'none' }} />
            <div className="OpenRom__Card__Icon">
                <OpenFolder />
            </div>
        </div>
    );
};

export default OpenRom;